import { Users, Circle } from 'react-feather'

export default [
	{
		header: 'Quản lý'
	},
	{
		id: 'character',
		title: 'Nhân vật',
		icon: <Users size={20} />,
		children: [
			{
				id: 'character-reset',
				title: 'Reset & ResetVIP',
				icon: <Circle size={12} />,
				navLink: '/character/reset'
			},

			{
				id: 'reset-point',
				title: 'Tẩy điểm & Master',
				icon: <Circle size={12} />,
				navLink: '/character/reset-point'
			},
			{
				id: 'clear-pk',
				title: 'Rửa tội',
				icon: <Circle size={12} />,
				navLink: '/character/clear-pk'
			},
			{
				id: 'change-name',
				title: 'Đổi tên',
				icon: <Circle size={12} />,
				navLink: '/character/change-name'
			},
			{
				id: 'change-class',
				title: 'Đổi giới tính',
				icon: <Circle size={12} />,
				navLink: '/character/change-class'
			},
			{
				id: 'rank-title',
				title: 'Danh hiệu',
				icon: <Circle size={12} />,
				navLink: '/character/title'
			}
			// {
			// 	id: 'quest-day',
			// 	title: 'Nhiệm vụ ngày',
			// 	icon: <Circle size={12} />,
			// 	navLink: '/character/questdaily'
			// }
			// {
			//     id: 'move',
			//     title: 'Di chuyển',
			//     icon: <Circle size={12} />,
			//     navLink: '/character/move'
			// },
			// {
			//     id: 'resetquest',
			//     title: 'Làm lại Quest',
			//     icon: <Circle size={12} />,
			//     navLink: '/character/resetquest'
			// },
		]
	}
]
